<template>
    <div>
        <PageHeader title="门店积分返利详情" hidden-breadcrumb>
            <div slot="back" @click="jumpPrevPage">
                <Icon type="md-arrow-back" />
            </div>
        </PageHeader>
        <Card :bordered="false" dis-hover class="ivu-mt">
            <table-form :formList="formList" @on-submit="onSubmit" @on-export="exportInfo" ref="table-form">
                <Button class="ivu-ml-8" :loading="isExporting" slot="extraBtn" type="error">导出</Button>
            </table-form>
            <table-page @onPageChange="onPageChange" @onPageSizeChange="onPageSizeChange" :list="list" />
        </Card>
    </div>
</template>

<script>
import tablePage from '@/components/tablePage';
import tableForm from '@/components/tableForm';
import { clearEmpty, jumpPage, transPathToName } from '@/libs/util';
import { storeRebateDetail, storeRebateDetailExport } from '@/api/statistics';
import { mapActions } from 'vuex';

export default {
    name: 'store-scan-storeRebateDetail',
    components: {
        tableForm,
        tablePage,
    },
    data() {
        return {
            isExporting: false,
            isChangePage: false,
            formList: [
                {
                    title: '商品名称',
                    type: 'input',
                    key: 'productName',
                    placeholder: '请输入商品名称',
                },
                {
                    title: '胎号',
                    type: 'input',
                    key: 'tyreCode',
                    placeholder: '请输入胎号',
                },
                {
                    title: '条码',
                    type: 'input',
                    key: 'barcode',
                    placeholder: '请输入条码',
                },
            ],
            searchParams: {
                scanTimeStr: this.$route.query.scanTimeStr,
                storeId: this.$route.query.storeId || '',
                distributorId: this.$route.query.distributorId,
                tiresName: '',
                tyrecode: '',
                scanCodeType: '',
                barcode: '',
                isHistory: '',
            },
            list: {
                current: 1,
                size: window.$pageSize,
                total: 0,
                loading: false,
                isChangePage: false,
                columns: [
                    {
                        title: '商品名称',
                        key: 'productName',
                        align: 'center',
                        minWidth: 220,
                    },
                    {
                        title: '系列',
                        key: 'brandSeries',
                        align: 'center',
                        minWidth: 100,
                    },
                    {
                        title: '品牌',
                        key: 'brandName',
                        align: 'center',
                        minWidth: 100,
                    },
                    {
                        title: '尺寸',
                        key: 'porductSize',
                        align: 'center',
                        minWidth: 100,
                    },
                    {
                        title: '胎号',
                        key: 'tyreCode',
                        align: 'center',
                        minWidth: 100,
                    },
                    {
                        title: '条码',
                        key: 'barcode',
                        align: 'center',
                        minWidth: 100,
                    },
                    {
                        title: '返利',
                        key: 'storeRebate',
                        align: 'center',
                        minWidth: 100,
                    },
                    {
                        title: '扫码时间',
                        key: 'scanTime',
                        align: 'center',
                        minWidth: 100,
                    },
                    {
                        title: '类型',
                        key: 'scanTypeStr',
                        align: 'center',
                        minWidth: 100,
                    },
                    {
                        title: '备注',
                        key: 'remark',
                        align: 'center',
                        minWidth: 100,
                    },
                ],
                data: [],
            },
        };
    },
    mounted() {
        this.getData();
        this.$bus.$on('refresh', this.getData);
    },
    beforeDestroy() {
        this.$bus.$off();
    },

    methods: {
        ...mapActions('admin/page', ['close']),
        getData(p) {
            this.list.loading = true;
            p = clearEmpty(this.searchParams);
            let params = {
                current: this.list.current,
                size: this.list.size,
                ...p,
            };
            storeRebateDetail(params).then(
                (res) => {
                    this.list.data = res.records || [];
                    this.list.total = Number(res.total);
                    this.isChangePage = false;
                    this.list.loading = false;
                },
                () => {
                    this.isChangePage = false;
                    this.list.loading = false;
                },
            );
        },
        async exportData() {
            let p = clearEmpty(this.searchParams);
            let params = {
                ...p,
            };
            try {
                this.isExporting = true;
                this.$Message.loading({ content: '导出中...', duration: 0 });
                await storeRebateDetailExport(params);
                this.isExporting = false;
                this.$Message.destroy();
                this.$Modal.confirm({
                    title: '提示',
                    content: `您好！“${this.$route.meta.title}”正在导出，请稍后在“导出列表”模块中查看，谢谢！`,
                    onOk: () => {},
                });
            } catch (error) {
                this.isExporting = false;
                this.$Message.destroy();
            }
        },
        onPageChange(val) {
            if (this.isChangePage) return;
            this.list.current = val;
            this.getData();
        },
        onPageSizeChange(val) {
            this.list.current = 1;
            this.isChangePage = true;
            this.list.size = val;
            this.getData();
        },
        check(row) {
            this.$refs['records'].open(row);
        },
        onSubmit(params) {
            this.list.current = 1;
            this.searchParams = {
                ...this.searchParams,
                ...params,
            };
            this.getData();
        },
        exportInfo(params) {
            if (this.isExporting) {
                return false;
            }
            this.searchParams = {
                ...this.searchParams,
                ...params,
            };
            this.exportData();
        },
        jumpPrevPage() {
            window.$basePageStore.closeTab(transPathToName(location.pathname));
            jumpPage({ path: '/sub-vue2/statistics/store/rebate' });
        },
    },
};
</script>
